<div class="schedule-container">
  <div *ngIf="isLoading" class="loading-container">
    <p>Cargando información del mentor...</p>
  </div>

  <div *ngIf="!isLoading && mentor" class="schedule-content">
    <!-- Encabezado y navegación -->
    <div class="header">
      <div class="back-link" (click)="goBack()">
        <mat-icon>arrow_back</mat-icon>
        <span>Inicio / agendar cita</span>
      </div>
      <!-- <div class="plan-info">
        <span class="plan-badge">{{subscription.name || ''}}</span>
      </div> -->
    </div>

    <!-- Sección principal -->
    <h1 class="title">Agendar cita</h1>

    <!-- Información del mentor -->
    <div class="mentor-card">
      <div class="mentor-details">
        <div class="mentor-photo-container">
          <!-- <img *ngIf="mentor.photo" [src]="mentor.photo" alt="Foto de {{mentor.name}}" class="mentor-photo">
          <div *ngIf="!mentor.photo" class="placeholder-photo"></div> -->
          <img [src]="getProfilePhotoUrl()" alt="Foto de perfil" class="mentor-photo" />
        </div>
        <div class="mentor-info">
          <h2 class="mentor-name">{{mentor.name}}</h2>
          @if(mentor.type && mentor.type.id==2){
          <p class="mentor-title">Profesional en mentoría</p>
          }
          @if(mentor.type && mentor.type.id==4){
          <p class="mentor-title">Experto</p>
          }
          <div class="mentor-social">
            <mat-icon *ngIf="mentor.email">mail</mat-icon>
            <mat-icon *ngIf="mentor.coachProfileData?.contactLinks?.website">language</mat-icon>
            <mat-icon *ngIf="mentor.coachProfileData?.contactLinks?.linkedin">linkedin</mat-icon>
          </div>
        </div>
      </div>
      <div class="mentor-price">
        <span class="price">{{hourlyRate}}</span>
        <span class="price-period">por hora</span>
      </div>
      <div class="mentor-actions">
        <button class="action-btn" (click)="changeMentor()">Cambiar de profesional</button>
        <button class="action-btn profile-btn" (click)="goToProfile()">Ir al perfil</button>
      </div>
    </div>

    <!-- Sección de disponibilidad -->
    <div class="availability-section">
      <h3 class="section-title">Disponibilidad</h3>

      <div class="date-navigation">
        <button class="nav-btn" (click)="navigateToPreviousDays()"
          [disabled]="currentDayOffset === 0"><mat-icon>arrow_back_ios</mat-icon></button>
        <span class="date-range">{{ getCurrentDateRange() }}</span>
        <button class="nav-btn" (click)="navigateToNextDays()"><mat-icon>arrow_forward_ios</mat-icon></button>
      </div>

      <div class="appointment-container">
        <!-- Sección de fechas -->
        <div class="date-section">
          <h4 class="section-subtitle">Fecha</h4>
          <div class="date-selector">
            <div *ngFor="let date of displayableDates; let i = index" class="date-box" [ngClass]="{
                'selected': date.selected, 
                'today': date.isToday,
                'unavailable': !date.available}" (click)="selectDate(date)">
              <span class="day">{{date.dayName}}</span>
              <span class="date-number">{{date.dayNumber}}</span>
            </div>
          </div>
        </div>

        <!-- Sección de horario -->
        <div class="time-section">
          <h4 class="section-subtitle">Horario</h4>
          <div class="time-info">
            <span class="selected-date">Seleccionado: <strong>{{ selectedDate | date:'EEEE dd MMMM':'':'es-PE' }}</strong> </span>
          </div>

          <div class="time-options">
            <div class="time-filter">
              <button *ngFor="let filter of timeFilters; let i = index" class="time-filter-btn"
                [ngClass]="{'active': filter.active}" (click)="selectTimeFilter(i)">
                {{filter.name}}
              </button>
            </div>

            <div class="time-slots" *ngIf="selectedDate">
              <button *ngFor="let slot of displayableTimeSlots; let i = index" class="time-slot-btn" [ngClass]="{
                  'selected': slot.selected, 
                  'booked': slot.isBooked && !slot.isPastTime,
                  'past-time': slot.isPastTime
                }" (click)="selectTimeSlot(slot)" [disabled]="slot.isBooked || slot.isPastTime"
                [title]="slot.isPastTime ? 'Horario no disponible (ya pasó)' : (slot.isBooked ? 'Horario ya reservado' : '')">
                {{slot.displayTime}}
              </button>
              <p *ngIf="displayableTimeSlots.length === 0 && selectedDate" class="no-slots-msg">
                No hay horarios disponibles en este periodo para la fecha seleccionada.
              </p>
            </div>
            <p *ngIf="!selectedDate" class="no-slots-msg">
              Selecciona una fecha para ver los horarios disponibles.
            </p>
          </div>
        </div>
      </div>

      <!-- Botón para agendar -->
      <div class="action-container">
        <button class="schedule-btn" (click)="showSummary()" [disabled]="!selectedTimeSlot || isLoading">
          {{ isLoading ? 'Procesando...' : 'Agendar una cita' }}
        </button>
      </div>
    </div>
  </div>

  <!-- Modal de resumen antes de confirmar reserva -->
  <div class="modal-overlay" *ngIf="showSummaryModal">
    <div class="modal-container summary-modal">
      <div class="modal-content">
        <!--  <div class="modal-timer">{{countdown}}</div> -->
        <h2 class="modal-title">Resumen</h2>

        <div class="modal-body">
          <p class="modal-description">Revisa detenidamente los datos de tu reservación:</p>

          <div class="reservation-details">
            <div class="detail-row">
              <span class="detail-label">Fecha:</span>
              <span class="detail-value">{{selectedDate | date:'EEEE dd MMMM yyyy'}}</span>
            </div>

            <div class="detail-row">
              <span class="detail-label">Hora:</span>
              <span class="detail-value">{{selectedTimeSlot?.displayTime}}</span>
            </div>

            <div class="detail-row">
              <span class="detail-label">Mentor/ Experto:</span>
              <span class="detail-value">{{mentor?.name}}, especialista en {{mentor?.coachProfileData?.professionalTitle
                || 'Administración'}}</span>
            </div>
          </div>

          <p class="notification-text">
            Una vez reservado podrás visualizarlo en tu calendario. Te avisaremos 30 minutos antes de tu cita.
          </p>

          <div class="contact-link">
            <span>Cualquier consulta adicional, </span>
            <a [routerLink]="['/contact-us']">contáctanos aquí</a>
          </div>

          <div class="terms-checkbox">
            <input type="checkbox" id="terms" [(ngModel)]="acceptTerms">
            <label for="terms">Aceptar <a
                href="https://docs.google.com/document/d/1cnOkFgUulOLgDuwyyIVyRcd6Ia92k4py/edit?usp=sharing&ouid=117612419140395349863&rtpof=true&sd=true"
                target="_blank">términos y condiciones de uso</a></label>
          </div>
        </div>

        <div class="modal-actions">
          <button class="btn-cancel" (click)="cancelReservation()">Cancelar</button>
          <button class="btn-confirm" (click)="confirmReservation()" [disabled]="!acceptTerms">Reservar ahora</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de éxito después de confirmación -->
  <div class="modal-overlay" *ngIf="showSuccessModal">
    <div class="modal-container success-modal">
      <div class="modal-content">
        <h2 class="modal-title">Reservado con éxito</h2>

        <div class="modal-body">
          <p class="modal-description">Datos de tu reservación:</p>

          <div class="reservation-details">
            <div class="detail-row">
              <span class="detail-label">Fecha:</span>
              <span class="detail-value">{{selectedDate | date:'EEEE dd MMMM yyyy'}}</span>
            </div>

            <div class="detail-row">
              <span class="detail-label">Hora:</span>
              <span class="detail-value">{{selectedTimeSlot?.displayTime}}</span>
            </div>

            <div class="detail-row">
              <span class="detail-label">Mentor/ Experto:</span>
              <span class="detail-value">{{mentor?.name}}, especialista en {{mentor?.coachProfileData?.professionalTitle
                || 'Administración'}}</span>
            </div>
          </div>

          <p class="notification-text">
            Se ha guardado con éxito tu reserva en el calendario. Te avisaremos 30 minutos antes de tu cita.
            Modifica la <a (click)="openNotificationSettings()">notificación aquí</a>.
          </p>

          <div class="contact-link">
            <span>Cualquier consulta adicional, </span>
            <a [routerLink]="['/contact-us']">contáctanos aquí</a>
          </div>
        </div>

        <div class="modal-actions">
          <button class="btn-calendar" (click)="afterSuccess(true)">Ir al calendario</button>
          <button class="btn-accept" (click)="afterSuccess(false)">Aceptar</button>
        </div>
      </div>
    </div>
  </div>
</div>